jQuery.lib_reveal = function() {
    if (!$("html.ie9").length && !$("html.no-sr").length && $("html.sr").length) {

        let reveal_group = [];
        let reveal_element = [];

        let options = {
            delay: 0,
            distance: 0,
            duration: 0,
            scale: 1,
            opacity: null,
            viewFactor: 0.2,
            mobile: true,
            rotate: {
                x: 0,
                y: 0,
                z: 0
            }
        };

        let callbacks = {
            beforeReveal: function (el) {
                if ($(el).find("[data-number-anim]").length) {
                    $.importScript(cdnjs.countup,function () {
                        $(el).find("[data-number-anim]").each(function () {
                            let number = $(this);

                            let options = {
                                separator: ' ',
                                decimal: (number.data("number-anim").decimal === undefined) ? "." : number.data("number-anim").decimal,
                                prefix: (number.data("number-anim").prefix === undefined) ? "" : number.data("number-anim").prefix,
                                suffix: (number.data("number-anim").suffix === undefined) ? "" : number.data("number-anim").suffix,
                            };

                            let countDecimals = function (value) {

                                if(Math.floor(value) === value) return 0;

                                if (value.indexOf(".") !== -1) {
                                    return value.toString().split(".")[1].length || 0;
                                } else {
                                    return 0;
                                }
                            };

                            let counter = new CountUp(number.get(0),0,number.text().replace(/[^\d.-]/g,''),countDecimals(number.text().replace(/[^\d.-]/g,'')), 2,options);
                            if (!counter.error) {
                                counter.start();
                            } else {
                                console.error(counter.error);
                            }
                        });
                    });
                }
                if($(el).find("[data-lib-map]").length){
                    $(el).find("[data-lib-map-load]").data("lib-map-load",true);
                    window.lui.lib["lib_map"]("lib_map",$(el).find("[data-lib-map]"));
                }
                if($(el).is("[data-lib-reveal-trigger]")) {
                    $(el).find("[data-lib-load]").data("lib-load",true);

                    let lui_type = $(el).data("lib-reveal-trigger").type,
                        lui_name = $(el).data("lib-reveal-trigger").name;

                    window.lui[lui_type][lui_name]([lui_type],$(el).closest(lui_name));
                }
                $(el).attr("data-lib-reveal", "revealed");
            },
            afterReveal: function(el) {
                $(el).removeAttr("style");
            }
        };

        $("[data-lib-reveal-group]").each(function () {
            let d = $(this).data("lib-reveal-group");
            reveal_group.indexOf(d) === -1 && reveal_group.push(d);
        });

        $("[data-lib-reveal]").each(function () {
            let name = $(this).data("lib-reveal");
            if (name !== "single") {
                reveal_element.indexOf(name) === -1 && reveal_element.push(name);
            }
        });

        bodyLoaded(function () {
            ScrollReveal().reveal('[data-lib-reveal="single"]', $.extend(options, callbacks, {interval: null}));

            reveal_group.forEach(function (d) {
                reveal_element.forEach(function (e) {
                    ScrollReveal().reveal(`[data-lib-reveal-group="${d}"] [data-lib-reveal="${e}"]`, $.extend(options, callbacks, {interval: d}));
                });
            });
        });
    } else {
        html.removeClass("sr").addClass("no-sr")
    }
};